export enum RoleTypeKeys {
  transferpoint = 'transferpoint',
  transferpointAdmin = 'transferpoint-admin',
  lpTransferpoint = 'lp-transferpoint',
  lpTransferpointAdmin = 'lp-transferpoint-admin',
  mbo = 'mbo',
  mboAdmin = 'mbo-admin',
  vo = 'vo',
  voAdmin = 'vo-admin',
  supervisor = 'supervisor',
  admin = 'admin',
  transfer = 'transfer',
  transferAdmin = 'transfer-admin',
  poAdmin = 'po-admin',
  po = 'po',
  daycareAdmin = 'daycare-admin',
  daycare = 'daycare',
  proAndVso = 'pro-and-vso',
  proAndVsoAdmin = 'pro-and-vso-admin',
  mboOutflow = 'mbo-outflow',
  mboOutflowAdmin = 'mbo-outflow-admin',
  work = 'work',
  workAdmin = 'work-admin',
  daytimeActivities = 'daytime-activities',
  daytimeActivitiesAdmin = 'daytime-activities-admin',
  transferpointRegionAdministrator = 'transferpoint-region-administrator'
}
